<script setup>
import { computed, ref } from 'vue';

const props = defineProps({
  modelValue: { type: [File, Object, null], default: null },
  accept: { type: String, default: '' },
  disabled: { type: Boolean, default: false },
  label: { type: String, default: '' },
  help: { type: String, default: '' },
});

const emit = defineEmits(['update:modelValue', 'change', 'clear']);

const inputRef = ref(null);

const fileName = computed(() => {
  const file = props.modelValue;
  return file && typeof file === 'object' && 'name' in file ? file.name : '';
});

const onChange = (e) => {
  const file = e?.target?.files?.[0] || null;
  emit('update:modelValue', file);
  emit('change', file);
};

const clear = () => {
  emit('update:modelValue', null);
  emit('clear');
  if (inputRef.value) inputRef.value.value = '';
};
</script>

<template>
  <div class="file-input">
    <label v-if="label" class="form-label fw-medium">{{ label }}</label>

    <div class="d-flex align-items-center gap-2">
      <input
        ref="inputRef"
        class="form-control"
        type="file"
        :accept="accept"
        :disabled="disabled"
        @change="onChange"
      />

      <button
        v-if="modelValue"
        type="button"
        class="btn btn-outline-secondary"
        :disabled="disabled"
        @click="clear"
        aria-label="Quitar archivo"
      >
        Quitar
      </button>
    </div>

    <small v-if="fileName" class="text-muted d-block mt-2">Archivo: {{ fileName }}</small>
    <small v-else-if="help" class="text-muted d-block mt-2">{{ help }}</small>
  </div>
</template>

<style scoped>
.file-input .btn {
  white-space: nowrap;
}
</style>
